import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { GetallDuplicateNumbersReports } from '../../Features/reports/Duplicatenumberreports';
import { RootState, AppDispatch } from '../../Appstore/store';
import { RenderPaginationButtons } from '../../Components/Paginations';
import HelpText from '../../Components/HelpText';
import { BiExport } from 'react-icons/bi';
import { GetallDuplicateNumbersReportDawnlaod } from '../../Features/reports/Duplicatenumberreportsdawnload';

function SmscampaignReportsList() {
    const [search, setSearch] = useState<string>('');
    const [isExporting, setIsExporting] = useState(false);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const limit = 10;
    const dispatch = useDispatch<AppDispatch>();
    const location = useLocation();
    const isActive = (path: string) => location.pathname === path ? 'active' : '';
    const [debouncedSearch, setDebouncedSearch] = useState<string>(search);

    const { duplicatereportdata, info, loading, error } = useSelector((state: RootState) => state.duplicatenumberreports);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearch(search.trim());
        }, 800);

        return () => {
            clearTimeout(handler);
        };
    }, [search]);

    useEffect(() => {
        dispatch(GetallDuplicateNumbersReports({ search: debouncedSearch, page: currentPage, limit }));
    }, [dispatch, debouncedSearch, currentPage, limit]);

    const handlePageChange = (page: number) => {
        if (page > 0 && page <= (info?.total_page || 1)) {
            setCurrentPage(page);
        }
    };

    const handleDownload = () => {
        setIsExporting(true);
        dispatch(GetallDuplicateNumbersReportDawnlaod({
            search: search,
            page: currentPage,
            limit: limit,
        }))
            .then((response) => {
                if (response.meta.requestStatus === 'fulfilled' && response.payload instanceof Blob) {
                    const blob = response.payload;

                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = `Duplicate-Numbers-Report_${new Date().toISOString()}.xlsx`;

                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            })
            .finally(() => {
                setTimeout(() => {
                    setIsExporting(false);;
                }, 500);
            });
    };

    const message = location.state?.message;

    if (error) {
        <div>No found data</div>
    }

    return (
        <>
            <div className="wrapper">
                <div className="content-wrapper">
                    <section className="content">
                        <div className="container-fluid">
                            <div className="card mt-4 shadow-sm border rounded">
                                <div className="card-header bg-white p-3 d-md-flex justify-content-md-between align-items-center">
                                    <h2 className="w-100 text-md-start text-center mb-md-2 mb-3 fs-3">Duplicate Numbers Reports</h2>
                                    <div className='d-flex justify-content-between align-items-center mb-md-0 my-3'>
                                        <div className="input-group input-group-sm pe-sm-3 search-input">
                                            <input
                                                type="search"
                                                className="form-control  float-right height-40px shadow-none"
                                                placeholder="Search Numbers"
                                                value={search}
                                                onChange={(e) => setSearch(e.target.value)}
                                            />
                                            <div className="input-group-append">
                                                <button type="submit" className="btn border cursor-pointer-none">
                                                    <i className="fas fa-search" />
                                                </button>
                                            </div>

                                        </div>
                                        <button
                                            onClick={handleDownload}
                                            className='width-reports-header-buttons btn btn-info bg-success ms-2 text-white d-flex rounded-2 align-items-center fw-semibold'
                                            disabled={isExporting}
                                        >
                                            <BiExport className='fs-5' />
                                            {isExporting ? 'Exporting...' : `Export `}
                                        </button>
                                    </div>
                                </div>
                                <>
                                    <div className='table-responsive'>
                                        <table className="table table-hover table-bordered text-nowrap">
                                            <thead>
                                                <tr>
                                                    <th className='ps-3 sr-no'>SR No</th>
                                                    <th style={{ minWidth: 100 }}>Campaign Names</th>
                                                    <th style={{ minWidth: 300 }}>Numbers</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {loading ? (
                                                    <tr>
                                                        <td colSpan={7} height={100}>
                                                            <div className="text-center" >
                                                                <div className="loader"></div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ) : !duplicatereportdata || duplicatereportdata.length === 0 ? (
                                                    <tr className='border-bottom-0'>
                                                        <td colSpan={7} height={50}>
                                                            <div className="text-center" >
                                                                <p className='mb-0 fs-5 fw-semibold'>No data found</p>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    duplicatereportdata?.map((item, index) => (
                                                        <tr key={item.id}>
                                                            <td className='ps-3'>{(currentPage - 1) * limit + index + 1}</td>
                                                            <td>
                                                                {item.campaign_names ? (
                                                                    item.campaign_names.split("\n").map((campaign, idx) => (
                                                                        <div key={idx}>{campaign.trim()}</div>
                                                                    ))
                                                                ) : (
                                                                    <span>-</span>
                                                                )}
                                                            </td>
                                                            <td>{item.number}</td>
                                                        </tr>
                                                    ))

                                                )}
                                            </tbody>
                                        </table>
                                    </div>

                                    {!duplicatereportdata || duplicatereportdata.length === 0 ? (
                                        <div></div>
                                    ) : (
                                        <div className="pagination d-flex flex-wrap justify-content-center align-items-center my-4 mx-3">
                                            <RenderPaginationButtons
                                                info={info}
                                                currentPage={currentPage}
                                                handlePageChange={handlePageChange}
                                            />
                                        </div>
                                    )}
                                </>
                            </div>
                        </div>
                    </section>
                </div>
            </div>

        </>
    )
}

export default SmscampaignReportsList
